import type {ManifestActionValue} from '../actions/types'

export abstract class DisplayFiltersActions {
    protected abstract getHiddenActions(): Record<string, ManifestActionValue>

    private getHiddenFilters = (): string[] => {
        return Object.keys(this.getHiddenActions())
    }

    public build = () => {
        return {
            hide: this.getHiddenFilters()
        }
    }
}
